import { render, staticRenderFns } from "./AspectRatio.vue?vue&type=template&id=e316e7a4"
import script from "./AspectRatio.vue?vue&type=script&lang=js"
export * from "./AspectRatio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports